import {
  action,
  observable
} from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import {
  DbKey
} from '../../../../adl-gen/common/db';
import {
  AppClient
} from '../../../../adl-gen/totalinteraction/futurefit/db';
import {
  Loader
} from '../../../../loader/loader';
import { AppClientData, AppClientStore } from '../../../stores';
import { FormMode } from '../../common/form';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';
import { AppClientForm } from '../../components/forms/appclient-form/appclient-form';
import { AppClientDetailsView } from '../../components/detail-views/appclient-details-view';

interface AppClientDetailScreenProps {
  pageLayout: AdminPageLayoutFn;
  mode?: FormMode;
  store: AppClientStore;

  onCancel?(): Promise<void>;
  onUpdate?(appClientId: DbKey<AppClient>): Promise<void>;
}

@observer
export class AppClientDetailScreen extends React.Component<AppClientDetailScreenProps> {
  /// If modals used...
  @observable.ref isOpen = false;

  @action toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }

  ClientDetailsView = observer(({ clientData }: { clientData: AppClientData }) => {
    const { onUpdate, store } = this.props;

    if (clientData.appClient && onUpdate) {
      return (
        <AppClientDetailsView
          client={clientData.appClient}
          providers={clientData.learningProviderList.items}
          onUpdate={onUpdate}
          role={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
    } else {
      return null;
    }
  });

  UpdateClientForm = observer(({ clientData }: { clientData: AppClientData }) => {
    const { mode, onCancel, store } = this.props;

    const repository = store.loadingRepository.kind === 'value' ? store.loadingRepository.value : undefined;
    if (repository && onCancel) {
      return (
        <AppClientForm
          client={clientData.appClient}
          clientData={clientData}
          store={store}
          repository={repository}
          selectMode="reload"
          mode={mode}
          onCancel={onCancel}
          isOpen={true}
        />
      );
    } else {
      return null;
    }
  });

  CreateClientForm = observer(({ clientData }: { clientData: AppClientData }) => {
    const { mode, onCancel, store } = this.props;

    const repository = store.loadingRepository;
    if (repository.kind === 'value' && onCancel) {
      return (
        <AppClientForm
          clientData={clientData}
          store={store}
          repository={repository.value}
          selectMode="reload"
          mode={mode}
          onCancel={onCancel}
          isOpen={true}
        />
      );
    } else {
      return null;
    }
  });

  ClientDetailsLoader = (clientData: AppClientData) => {
    const { mode } = this.props;
    if (clientData.appClient) {
      if (mode === 'update' || mode === 'delete') {
        return <this.UpdateClientForm clientData={clientData} />;
      } else {
        /// View
        return <this.ClientDetailsView clientData={clientData} />;
      }
    } else {
      /// Create - mode doesn't matter
      return <this.CreateClientForm clientData={clientData} />;
    }
  };

  render() {
    const { store } = this.props;
    return (
      <this.props.pageLayout
        title={'Administration - Client'}
      >
        <Loader state={store.loadingData} LoadedComponent={this.ClientDetailsLoader} />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/appclient-detail-screen/appclient-detail-screen.tsx